import "../styles/storyHome.css";
import React, { useRef, useEffect, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { ref, onValue } from "firebase/database";
import { db } from "../firebaseConfig";
import { useNavigate } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";

import ScrollAnimation from "./ScrollAnimation";

const EAGER_IMAGE_COUNT = 4;

function StoryHome() {
  const navigate = useNavigate();
  const [stories, setStories] = useState([]);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const swiperRef = useRef(null);

  useEffect(() => {
    const imoveisRef = ref(db, "imoveisPublicos/");

    onValue(imoveisRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const imoveisArray = Object.keys(data)
          .map((key) => ({
            id: key,
            ...data[key],
          }))
          .filter(
            (imovel) =>
              imovel?.imovelInfo?.modalidade === "Venda" && imovel?.imovelInfo?.status === true ||
              imovel?.imovelInfo?.modalidade === "Aluguel" && imovel?.imovelInfo?.status === true
          )
          .reverse()
          .slice(0, 25);

        setStories(imoveisArray);
      } else {
        setStories([]);
      }
    });
  }, []);

  const handleClick = (codigo) => {
    navigate(`/imovel/${codigo}`);
  };

  const updateNavState = (swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  return (
    <div className="story-carousel">
      <ScrollAnimation animation="fade-up" duration={1500}>
        <div className="story-carousel__inner">
          <div className="story-carousel__header">
            <h3>
              Veja nossos <strong>imóveis recentes</strong>
            </h3>
            <div className="story-carousel__nav">
              <button
                type="button"
                className="story-nav-button"
                aria-label="Ver imóveis anteriores"
                disabled={isBeginning}
                onClick={() => swiperRef.current?.slidePrev()}
              >
                <FaChevronLeft />
              </button>
              <button
                type="button"
                className="story-nav-button"
                aria-label="Ver próximos imóveis"
                disabled={isEnd}
                onClick={() => swiperRef.current?.slideNext()}
              >
                <FaChevronRight />
              </button>
            </div>
          </div>

          <div className="story-carousel__viewport">
            {stories.length > 0 ? (
              <Swiper
                modules={[FreeMode, A11y]}
                onSwiper={(swiper) => {
                  swiperRef.current = swiper;
                  updateNavState(swiper);
                }}
                onSlideChange={updateNavState}
                onReachBeginning={updateNavState}
                onReachEnd={updateNavState}
                onFromEdge={updateNavState}
                watchOverflow
                slidesPerView="auto"
                spaceBetween={15}
                loop={false}
                autoplay={false}
                grabCursor
                resistanceRatio={0.65}
                freeMode={{ enabled: true, momentum: true, momentumRatio: 0.8, sticky: false }}
                className="story-swiper"
              >
                {stories.map((property, index) => (
                  <SwiperSlide key={property.id} className="story-slide">
                    <div
                      className="bloco"
                      onClick={() => handleClick(property.imovelInfo.codigo)}
                      role="link"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          handleClick(property.imovelInfo.codigo);
                        }
                      }}
                    >
                      <img
                        src={
                          property.imagesLinks?.[0] ||
                          "https://via.placeholder.com/300x420"
                        }
                        alt={`Imóvel ${property.id}`}
                        loading={index < EAGER_IMAGE_COUNT ? "eager" : "lazy"}
                        decoding="async"
                        width="230"
                        height="320"
                      />
                      <div
                        className={`overlay ${property.imovelInfo.modalidade === "Venda"
                          ? "venda"
                          : "aluguel"
                          }`}
                      />
                      <div className="label">{property.imovelInfo.modalidade}</div>
                      <div className="label tipo">{property.imovelInfo.tipo}</div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <p className="story-carousel__empty">Nenhum imóvel disponível.</p>
            )}
          </div>
        </div>
      </ScrollAnimation>
    </div>
  );
}

export default StoryHome;
